import { useSearchParams } from "react-router";

import { Spinner } from "@/components/ui/spinner";

import { useClinicians } from "../../api/get-clinicians";
import { ClinicianCard } from "./clinician-card";

export const ClinicianList = () => {
    // Get Clinicians
    let [searchParams] = useSearchParams();
    const params = Object.fromEntries([...searchParams]);
    const { data: clinicians = [], isLoading } = useClinicians(params);

    if (isLoading) {
        return (
            <div className="relative mx-auto flex-1">
                <div className="inset-0 z-10">
                    <div className="grid h-50 place-items-center py-10">
                        <Spinner size="lg" />
                    </div>
                </div>
            </div>
        );
    }

    if (clinicians?.length === 0) {
        return (
            <div className="flex-1 py-10 text-center text-xl text-neutral-500">
                <p>No clinicians matched your filters</p>
            </div>
        );
    }

    return (
        <div className="flex-1">
            <h1 className="text-2xl font-semibold text-darkgreen-300">
                Available Clinicians
            </h1>
            <p className="mb-4 w-full text-neutral-500">
                {clinicians.length} vetted clinican
                {clinicians.length > 1 && "s"} · available today
            </p>
            <div className="col-span-full grid grid-cols-12 space-y-4">
                {clinicians.map((clinician) => {
                    return (
                        <ClinicianCard
                            key={clinician.userID}
                            clinician={clinician}
                        />
                    );
                })}
            </div>
        </div>
    );
};
